import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

import BTlogo from "../../assets/BT-logo.png";
import PWSlogo from "../../assets/PWS-logo.png";

import BigTrunk from "../../assets/BigTrunk.png";
import PWS from "../../assets/PWS.png";

export function WorkExperience() {
  return (
    <Container id="work-experience">
      <h2>Work Experience</h2>
      <div className="timeline">

        {/* Big Trunk */}
        <ScrollAnimation animateIn="fadeInLeft">
          <div className="experience-card row">
            <div className="text-section">
              <div className="header">
                <img className="logo" src={BTlogo} alt="MTA Logo" />
                <div>
                  <h3>Account Manager</h3>
                  <span className="company">Big Trunk Communications</span>
                  <span className="date">Nov 2021 – July 2023</span>
                </div>
              </div>
              <div className="desc">
                <p>Managed integrated marketing campaigns for Discovery Kids India, Cartoon Network, Pogo, and Toys“R”Us, spanning digital, social, and on-ground activations</p>
                <hr />
                <p>Led client servicing and cross-functional coordination, partnering with creative, media, SEO, influencer, and analytics teams to deliver cohesive campaigns</p>
                <hr />
                <p>Supported YouTube growth and content optimisation, contributing to channel scale from 10K to 5M subscribers and a 40% increase in ad revenue</p>
                <hr />
                <p>Delivered hybrid movie launch campaigns combining digital strategy, influencer collaborations, Snapchat AR filters, and kids’ events, driving 67% growth in engagement</p>
              </div>
            </div>
            <img className="preview" src={BigTrunk} alt="BigTrunk" />
          </div>
        </ScrollAnimation>

        {/* PWS */}
        <ScrollAnimation animateIn="fadeInRight">
          <div className="experience-card row row-reverse">
            <div className="text-section">
              <div className="header">
                <img className="logo" src={PWSlogo} alt="Zuddl Logo" />
                <div>
                  <h3>Digital Marketing Executive</h3>
                  <span className="company">Perfect Web Solutions</span>
                  <span className="date">July 2019 – Oct 2021</span>
                </div>
              </div>
              <div className="desc">
                <p>Led social media and SEO strategies across multiple categories, aligning content with platform behaviour to drive consistent audience growth</p>
                <hr />
                <p>Developed and managed 500+ creative assets, strengthening brand presence, visibility, and keyword performance</p>
                <hr />
                <p>Supported branding, client servicing, and internal team workflows while building engaged online communities through insight-led content</p>
              </div>
            </div>
            <img className="preview" src={PWS} alt="PWS" />
          </div>
        </ScrollAnimation>

      </div>
    </Container>
  );
}
